<template>
  <div class="trailerCharts">
    <div v-once class="trailerCharts_title"> National spot rates</div>
    <template v-for="(itemData, keyName) in dataRates">
      <trailer-charts-item
          :key="keyName"
          :itemData="itemData"
          :keyName="keyName"
          :diagramValues="diagramValues"
      ></trailer-charts-item>
    </template>
    <div v-once class="trailerCharts_bottom">
      <span class="mr-2">Accurate rates provided by</span>
      <svg-sprite width="65" height="20" icon-id="dat"></svg-sprite>
    </div>
  </div>
</template>
<script>
import TrailerChartsItem from "@/components/Statistics/TrailerChartsItem/TrailerChartsItem";
import { trailerDefaultValues } from "@/components/Statistics/TrailerCharts/constants";
import getClonedObject from "@/helper/getClonedObject";

export default {
	components: { TrailerChartsItem },
	props: {
		dataRates: {
			type: [ Array, Object ],
			require: true,
			default: () => trailerDefaultValues,
		},
	},
	computed: {
		diagramValues() {
			const copy = getClonedObject(this.dataRates);
			return {
				van: Object.values(copy.van).sort((a, b) => a.amount - b.amount)[3].amount,
				flatbed: Object.values(copy.flatbed).sort((a, b) => a.amount - b.amount)[3].amount,
				reefer: Object.values(copy.reefer).sort((a, b) => a.amount - b.amount)[3].amount,
			};
		},
	},
};
</script>
<style lang="scss" scoped>
.trailerCharts {
	background: var(--card-bg);
	width: 315px;
	padding: 20px;
	height: 595px;
	border-radius: 5px;

	&_title {
		font-size: 16px;
		font-weight: 500;
		line-height: 20px;
		letter-spacing: 0.25px;
		text-align: left;
		margin-bottom: 20px;
		color: var(--card-color);
	}

	&_bottom {
		display: flex;
		align-items: center;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
		color: var(--card-color);
	}
}

</style>
